import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import type { TenantContentBlock } from '../types/theme'

interface HtGoldPaymentRatesModalProps {
  isOpen: boolean
  onClose: () => void
  content?: TenantContentBlock | null
}

const HtGoldPaymentRatesModal: React.FC<HtGoldPaymentRatesModalProps> = ({
  isOpen,
  onClose,
  content,
}) => {
  const [visible, setVisible] = useState(false)
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setVisible(false)
      return
    }
    setImageError(false)
    const id = window.setTimeout(() => setVisible(true), 40)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      window.clearTimeout(id)
      document.body.style.overflow = prev
    }
  }, [isOpen, content?.imageUrl])

  useEffect(() => {
    if (!isOpen) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [isOpen, onClose])

  if (!isOpen) return null

  const block = content ?? { type: 'text' as const, textContent: '', imageUrl: '' }
  const isImage =
    block.type === 'image' && Boolean(block.imageUrl?.trim()) && !imageError
  const showText = !isImage

  return createPortal(
    <div
      className={`htg-rates-modal${visible ? ' is-visible' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="อัตราการจ่าย"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className={`htg-rates-modal__panel${isImage ? ' htg-rates-modal__panel--image' : ''}`}>
        <button
          type="button"
          className="htg-rates-modal__close"
          aria-label="ปิด"
          onClick={onClose}
        >
          ×
        </button>
        {!isImage ? (
          <header className="htg-rates-modal__head">
            <span className="htg-rates-modal__badge" aria-hidden>
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path
                  fill="currentColor"
                  d="M12 2.5 14.8 9l6.7.6-5.1 4.4 1.6 6.5L12 17.4 6 20.5l1.6-6.5L2.5 9.6 9.2 9z"
                />
              </svg>
            </span>
            <h3>อัตราการจ่าย</h3>
          </header>
        ) : null}
        <div className={`htg-rates-modal__body${isImage ? ' htg-rates-modal__body--image' : ''}`}>
          {showText ? (
            <div
              className="htg-rates-modal__html"
              dangerouslySetInnerHTML={{
                __html:
                  block.textContent?.trim() ||
                  '<p class="htg-rates-modal__empty">ยังไม่มีข้อมูลอัตราการจ่าย</p>',
              }}
            />
          ) : (
            <img
              className="htg-rates-modal__img"
              src={block.imageUrl}
              alt="อัตราการจ่าย"
              onError={() => setImageError(true)}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default HtGoldPaymentRatesModal
